import { render, staticRenderFns } from "./LiabilitiesTransferFieldsTab.vue?vue&type=template&id=999d0e62&scoped=true&"
import script from "./LiabilitiesTransferFieldsTab.vue?vue&type=script&lang=js&"
export * from "./LiabilitiesTransferFieldsTab.vue?vue&type=script&lang=js&"
import style0 from "./LiabilitiesTransferFieldsTab.vue?vue&type=style&index=0&id=999d0e62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999d0e62",
  null
  
)

export default component.exports